import dayjs from 'dayjs';
import { getCurrentTimeZone } from 'shared/helpers';

class Converter {
  convertGetSportHistory(data) {
    const coupons = data.items.map(item => {
      const date = getCurrentTimeZone(dayjs(item.created_at));

      return {
        id: item.id,
        userId: item.user_id,
        createdAt: date.format('DD.MM.YYYY HH:mm:ss'),
        createdAtMobile: date.format('MMMM D, YYYY, HH:mm:ss'),
        isExpress: item.is_express,
        provider: item.provider,
        amount: Number(item.amount).toFixed(2),
        currency: item.currency,
        coef: Number(item.coef).toFixed(2),
        possibleWinAmount: Number(item.possible_win_amount).toFixed(2),
        status: item.status,
        remoteCouponId: item.remote_coupon_id,
        username: item.username,
      }
    });

    return {
      items: coupons,
      count: data.count,
    };
  }

  convertGetCouponBets(data) {
    return data.map((item, i) => ({
      id: item.id,
      eventName: item.event_name,
      isLive: item.is_live,
      countryName: item.country_name,
      tournamentName: item.tournament_name,
      sportName: item.sport_name,
      outcome: item.outcome,
      coef: item.coef,
      score: item.score,
      status: item.status,
      isBetBuilder: item.is_bet_builder,
      betBuilderStakes: Array.isArray(item.bet_builder_stakes) ? item.bet_builder_stakes : [],
    }));
  }
}

export default Converter;
